
  function toggleHamburger (hamburgerButton, hamburgerWrapper, menuTarget, pageHeader, childMenuToggleButtons, pageBody) {
    // Event listener for the hamburger wrapper
    hamburgerWrapper.addEventListener("click", function () {
      hamburgerButton.classList.toggle("is-open");
      hamburgerWrapper.classList.toggle("is-open");
      menuTarget.classList.toggle("is-open");
      pageHeader.classList.toggle("is-open");
  
      if (pageBody && "hidden" !== pageBody.style.overflowY) {
        pageBody.style.overflowY = "hidden";
      } else {
        pageBody.style.overflowY = "initial";
      }
    });
  
    // Event listener for the child
    childMenuToggleButtons.forEach(function (childMenuToggleButton) {{
      childMenuToggleButton.addEventListener("click", function () {
        childMenuToggleButton.classList.toggle("is-open");
        childMenuToggleButton.nextElementSibling.classList.toggle("is-open");
      });
    }})
}  

document.addEventListener("DOMContentLoaded", function () {
    const hamburgerButton = document.querySelector(".js-header-hamburger-button"),
          hamburgerWrapper = document.querySelector(".js-hamburger-wrapper"),
          menuTarget = document.querySelector(".js-menu-target"),
          pageHeader = document.querySelector(".js-header"),
          childMenuToggleButtons = document.querySelectorAll(".js-nav-child-menu-toggle-button"),
          pageBody = document.body;
  
    if (hamburgerWrapper) {
      toggleHamburger(hamburgerButton, hamburgerWrapper, menuTarget, pageHeader, childMenuToggleButtons, pageBody);
    }
  });